import { render, staticRenderFns } from "./MyGoodsOrderDetail.vue?vue&type=template&id=339858a2&scoped=true&"
import script from "./MyGoodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MyGoodsOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339858a2",
  null
  
)

export default component.exports